import React from 'react';
import type { PersonCommunicationData } from '@gov-nx/core/hooks';
import { LocalizeNameSpaceTypes, useLocale } from '@gov-nx/core/service';
import type { FormCheckboxProps, FormInputProps } from '@gov-nx/ui/types';
import {
	Button,
	FormCheckbox,
	FormInput,
	FormWidthElementLayout,
	Icon,
} from '@gov-nx/ui/web';
import { CommunicationInputWrapper } from './CommunicationInputWrapper';

interface UseCommunicationDataAddressProps {
	fields: {
		_useAddress: FormCheckboxProps;
		address: FormInputProps;
	};
	wcagLabels: {
		edit: string;
		cancel: string;
	};
	personCommunicationData: PersonCommunicationData;
	onReset: () => void;
	address?: string;
}

export const UseCommunicationDataAddress = ({
	personCommunicationData,
	onReset,
	wcagLabels,
	address,
	fields,
}: UseCommunicationDataAddressProps) => {
	const { t } = useLocale(LocalizeNameSpaceTypes.Form);

	return (
		<CommunicationInputWrapper>
			<FormCheckbox {...fields._useAddress} />
			{personCommunicationData.control.isEditingAddress.value ? (
				<div className="flex flex-row items-center gap-2 [ md:w-1/2 ]">
					<FormWidthElementLayout type="m">
						<FormInput {...fields.address} />
					</FormWidthElementLayout>
					{personCommunicationData.address && (
						<Button
							color="primary"
							type="base"
							size="m"
							onClick={() => {
								onReset();
							}}
							iconEnd={
								<Icon
									name="x-lg"
									type="components"
								/>
							}
							aria-label={wcagLabels.cancel}
						/>
					)}
				</div>
			) : (
				<div className="inline-flex items-center gap-2">
					<strong>{address ? address : <i>{t('empty')}</i>}</strong>
					<Button
						onClick={personCommunicationData.control.isEditingAddress.setTrue}
						aria-label={wcagLabels.edit}
						color="primary"
						size="s"
						type="base"
						iconEnd={
							<Icon
								name="pencil-square"
								type="templates"
							/>
						}
					/>
				</div>
			)}
		</CommunicationInputWrapper>
	);
};
